module.exports = __webpack_public_path__ + "static/media/makeup_face.f15caf1d.jpg";